import React, { useEffect, useState } from 'react';
import './PoolVerificationPoolDetails.css'
import { useDispatch, useSelector } from 'react-redux';
import { setPoolVerificationPath } from '../../redux/commonSlice';

function INCSUBPoolVerificationPoolDetailsCard() {
  const dispatch = useDispatch();
  const details = useSelector((state) => state.poolVerification.selectedVerificationPool);
  const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-GB", options).replace(",", "");
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const period = hours >= 12 ? "PM" : "AM";
    const formattedTime = `${hours % 12 || 12}:${minutes} ${period}`;

    return `${formattedDate} ${formattedTime}`;
  };

  return (
    <div className='INCSUBPoolInfo_card'>
      <div className='INCSUBPoolInfo_card_poolname_status_validity'>
        <div className='INCSUBPoolInfo_card_poolname_type'>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: 'pointer' }} onClick={() => {
            dispatch(setPoolVerificationPath('/poolverification'))
          }}>
            <path d="M19 12H5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 19L5 12L12 5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

          <div className='INCSUBPoolInfo_card_poolname'>{details?.poolName}</div>
          <div className='INCSUBPoolInfo_card_pooltype'>{details?.poolType}</div>
        </div>
      </div>
      <div className='INCSUBPoolInfo_card_pool_details'>
        <div className='INCSUBPoolInfo_card_pool_details_divs'>
          <div className='INCSUBPoolInfo_card_pool_details_name_img'>
            <div className='INCSUBPoolInfo_card_pool_details_hostedby_img'>
              <img className='INCSUB_UserImgTag' src={details ? details.hostImage : '/assets/icons/common/defaultImage.png'} alt={`${'default'} img`} />
            </div>
            <div className='INCSUBPoolInfo_card_pool_details_hostedby_name'>
              <p className='INCSUBPoolInfo_card_pool_details_hostedby_p'>Host</p>
              <p className='INCSUBPoolInfo_card_pool_details_hostedbyname_p'>{details?.hostName}</p>
            </div>
          </div>
        </div>
        <div className='INCSUBPoolInfo_card_pool_details_divs'>
          <div className='INCSUBPoolInfo_card_pool_details_name_img'>
            <div className='INCSUBPoolInfo_card_pool_details_hostedby_name'>
              <p className='INCSUBPoolInfo_card_pool_details_hostedby_p'>Created Date</p>
              <p className='INCSUBPoolInfo_card_pool_details_hostedbyname_p'>{formatDateTime(details?.poolCreatedAt)}</p>
            </div>
          </div>
        </div>
        <div className='INCSUBPoolInfo_card_pool_details_divs'>
          <div className='INCSUBPoolInfo_card_pool_details_name_img'>
            <div className='INCSUBPoolInfo_card_pool_details_hostedby_name'>
              <p className='INCSUBPoolInfo_card_pool_details_hostedby_p'>Size</p>
              <p className='INCSUBPoolInfo_card_pool_details_hostedbyname_p'>{details?.poolMemberSize} {details?.poolMemberSize>1?"Members":"Member"}</p>
            </div>
          </div>
        </div>
        <div className='INCSUBPoolInfo_card_pool_details_divs'>
          <div className='INCSUBPoolInfo_card_pool_details_name_img'>
            <div className='INCSUBPoolInfo_card_pool_details_hostedby_name'>
              <p className='INCSUBPoolInfo_card_pool_details_hostedby_p'>Amount</p>
              <p className='INCSUBPoolInfo_card_pool_details_hostedbyname_p'>₹ {details?.poolPlanPrice}</p>
            </div>
          </div>
        </div>
        <div className='INCSUBPoolInfo_card_pool_details_divs'>
          <div className='INCSUBPoolInfo_card_pool_details_name_img'>
            <div className='INCSUBPoolInfo_card_pool_details_hostedby_name'>
              <p className='INCSUBPoolInfo_card_pool_details_hostedby_p'>Validity</p>
              <p className='INCSUBPoolInfo_card_pool_details_hostedbyname_p'>{details?.poolValidDaysCount} days</p>
            </div>
          </div>
        </div>
        <div className='INCSUBPoolInfo_card_pool_details_divs'>
          <div className='INCSUBPoolInfo_card_pool_details_name_img'>
            <div className='INCSUBPoolInfo_card_pool_details_hostedby_name'>
              <p className='INCSUBPoolInfo_card_pool_details_hostedby_p'>Pool Start Date</p>
              <p className='INCSUBPoolInfo_card_pool_details_hostedbyname_p'>{details?.poolStartDate}</p>
            </div>
          </div>
        </div>
        <div className='INCSUBPoolInfo_card_pool_details_divs_last'>
          <div className='INCSUBPoolInfo_card_pool_details_name_img'>
            <div className='INCSUBPoolInfo_card_pool_details_hostedby_name'>
              <p className='INCSUBPoolInfo_card_pool_details_hostedby_p'>Pool End Date</p>
              <p className='INCSUBPoolInfo_card_pool_details_hostedbyname_p'>{details?.poolEndDate}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default INCSUBPoolVerificationPoolDetailsCard;
